import {
  asString,
  parseEligibleRegionsField,
  parseKnownValue,
  parseObject,
  parseRequiredArrayField,
} from '~/utils/societePayloadBuilder/parseHelpers';

import { LUXPLUS_PROMO_BANNER_CTA_LINK_TYPES } from '../constants';
import { parseOptionalExpiresAt } from '../payloadFields';
import { createPromoDraftLabel } from '../promos';

import { createDefaultPromoBanner } from './defaults';
import type { LuxPlusPromoBanner, LuxPlusPromoBannerCarouselState } from './types';

function parsePromo(value: unknown, index: number): LuxPlusPromoBanner {
  const source = parseObject(value, `Promo banner ${index + 1}`);
  const defaults = createDefaultPromoBanner(createPromoDraftLabel(index));

  return {
    ...defaults,
    label: asString(source.label),
    title: asString(source.title),
    ctaText: asString(source.ctaText),
    ctaLink: asString(source.ctaLink),
    ctaLinkType: parseKnownValue(
      source.ctaLinkType ?? 'link',
      LUXPLUS_PROMO_BANNER_CTA_LINK_TYPES,
      `${defaults.draftLabel} CTA link type`,
    ),
    expiresAt: parseOptionalExpiresAt(source.expiresAt),
    eligibleRegions: parseEligibleRegionsField(source, `${defaults.draftLabel} Eligible Regions`),
  };
}

export function parsePromoBannerCarouselPayload(value: unknown): LuxPlusPromoBannerCarouselState {
  const source = parseObject(value, 'Payload');
  const promos = parseRequiredArrayField(source, 'promos').map((promo, index) => parsePromo(promo, index));

  return {
    mode: 'promoBannerCarousel',
    promos,
  };
}
